;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');
	
	Model.FacebookLoginForm = Backbone.Model.extend({
		url: 'facebook_login',
		defaults: {}
	});

}(window, APP, Backbone, Marionette, $, _));